export const projectsData = [
    {
        id: 'fistikpazar',
        title: 'FıstıkPazar',
        shortDescription: 'Modern ve ölçeklenebilir B2B e-ticaret platformu.',
        category: 'E-Ticaret & Tarım Teknolojisi',
        image: '/images/fistikpazar1.png',
        liveUrl: 'https://fistikpazar.com/',
        technologies: ['Web Geliştirme', 'Mobil Uygulama', 'IoT', 'Yapay Zeka'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'FıstıkPazar, fıstık üretimini ve satışını daha kolay ve verimli hale getirmek amacıyla geliştirilmiş bir dijital platformdur. Bu yenilikçi uygulama sayesinde üreticiler, müşteriler ve danışmanlar için özel üyelik seçenekleri sunulmakta ve sektör ihtiyaçlarına yönelik kapsamlı çözümler sağlanmaktadır.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Üreticilerin tarla verilerini gerçek zamanlı olarak izlemesi',
                'Üç farklı kullanıcı tipi için özel özellikler geliştirilmesi',
                'IoT cihazlarından gelen verilerin yapay zeka ile analiz edilmesi',
                'Hem web hem de mobil platformlarda sorunsuz çalışan bir sistem oluşturulması'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'IoT sensörler ile tarla verilerinin anlık takibi ve kamera sistemleri entegrasyonu',
                'Yapay zeka tabanlı günlük değerlendirme raporları sistemi',
                'Üretici-danışman veri paylaşım platformu',
                'Responsive tasarım ile web ve mobil uyumlu arayüz',
                'B2B e-ticaret altyapısı ile kolay ürün satış sistemi'
            ]
        },
        features: {
            title: 'Üyelik Tipleri ve Platformun Özellikleri',
            items: [
                'Müşteri: Müşteriler, FıstıkPazar üzerinden kolaylıkla fıstık ürünleri satın alabilir, ürünler hakkında yorum yapabilir ve alışveriş deneyimlerini paylaşabilirler',
                'Üretici: Üreticiler, tarlalarına yerleştirilen ölçüm cihazları ve kameralar sayesinde sahaya gitmeden tarla durumunu uzaktan takip edebilirler. Ölçüm cihazları ile nem, sıcaklık, yağış gibi kritik veriler anlık olarak görüntülenebilir',
                'Yapay zeka teknolojisi kullanılarak, kameralar ve cihazlardan alınan veriler ile üreticiye günlük değerlendirme raporları sunulur',
                'Üretici, dilerse arazi verilerini danışmanları ile paylaşabilir ve bu sayede ek destek alabilirler',
                'Danışman: Danışmanlar, kendilerine izin verilen arazi verilerini inceleyerek üreticilere daha kesin ve veriye dayalı çözümler sunar',
                'Hem web hem de mobil uygulama olarak kullanılabilen FıstıkPazar, kullanıcı dostu arayüzü ile her yerden erişim sağlar',
                'Üreticiler için tarla takibi, anlık veri görüntüleme ve yapay zeka destekli analiz imkânı',
                'Danışmanlar için uzman görüşü paylaşma ve veriye dayalı önerilerde bulunma imkânı'
            ]
        }
    },
    {
        id: 'akillisera',
        title: 'Akıllı Sera',
        shortDescription: 'Yapay zeka destekli sera kontrol ve otomasyon sistemi.',
        category: 'IoT & Tarım Teknolojisi',
        image: '/images/akillisera.jpg',
        liveUrl: 'https://akillisera.abrh.com.tr/',
        technologies: ['IoT', 'Web Geliştirme', 'Mobil Uygulama', 'Yapay Zeka', 'Sensör Teknolojileri'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'Akıllı Sera, bitki ihtiyaçlarının manuel, otonom veya uzaktan kontrollü olarak verilebilmesini sağlayan AR-GE ye dayalı yerli üretim bir proje ürünüdür. Sera bilgilerini uzaktan okuyabildiğiniz, röleleri uzaktan kontrol edebildiğiniz, manuel talimatlar verebildiğiniz ve hatta talimatları otomatik hale getirebildiğiniz bir otomasyon sistemidir. Mahsuller kırılgan olabilir fakat gerekli koşullar sağlandığında iyi bir rekolte verir.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Sera ortam koşullarının 7/24 izlenmesi ve kontrol edilmesi gerekliliği',
                'Farklı sensör tiplerinin entegrasyonu ve veri senkronizasyonu',
                'Bitki hastalıklarının erken tespiti ve rekolte tahmininin yapılması',
                'Manuel işçilik maliyetlerinin yüksek olması ve insan hatasına açık olması',
                'İklim koşullarının bitkiler üzerindeki etkilerinin anlık takibi'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'Modüler yapı ile tüm tarım alanlarına kolayca entegrasyon sağlayan sistem',
                'Mobil ve web üzerinden uzaktan izleme ve kontrol kolaylığı',
                'Yapay zeka destekli hastalık tespiti ve rekolte tahmini özellikleri',
                'Otomatik sulama ve gübreleme sistemleri ile efor tasarrufu',
                'Çoklu sensör desteği: Sıcaklık, nem, pH, CO2, rüzgar hızı, meteorolojik veriler',
                'Yüksek çözünürlük kamera sistemi ile görsel takip'
            ]
        },
        features: {
            title: 'Özellikler',
            items: [
                'Sera İç ve Dış Ortam İklim Bilgileri: Web sitesi veya mobil uygulama üzerinden seranın iç-dış sıcaklık ve nem, toprak nem-sıcaklık ve pH, rüzgar hızı, meteorolojik veriler gibi bilgileri okuyabilme',
                'Bitkiden Hastalık Tespiti: Bitkinin resminden hastalık tespit edebilme özelliği',
                'Rekolte Tahmini: Yapay zeka destekli rekolte tahmini yapabilme özelliği',
                'Erken Uyarı Alarmı: Bitkiler veya sera zarar görmeden uyarılma sistemi',
                'Seralarınızda Tam Kontrol: Sıcaklık algılayıcıları (hava ve toprak sıcaklığı), nem algılayıcıları (hava nemi, toprak nemi), güneş ışınımı algılayıcıları, fotosentez etkili ışınım algılayıcıları, meteorolojik veriler, rüzgar hızı ölçer, pH ölçer, CO2 analizörü',
                'Yüksek çözünürlük kamera sistemi ile görsel izleme',
                'Merkezi güç kontrol ve yönetim sistemi',
                'Dahili modem ile uzaktan kontrol sistemi',
                'Akıllı telefon ile takip (Android)',
                'Otomatik sulama ve gübreleme ile verimlilik artışı',
                'Modüler donanım ve yazılım yapısı ile kolay kurulum'
            ]
        }
    },
    {
        id: 'kangrubu',
        title: 'Kan Grubu Tespit Cihazı',
        shortDescription: 'Yapay zeka destekli anlık kan grubu tespit sistemi.',
        category: 'Sağlık Teknolojisi & Yapay Zeka',
        image: '/images/kanbulucu.jpg',
        liveUrl: 'https://quickscanabrh.com/',
        technologies: ['Yapay Zeka', 'Web Geliştirme', 'Donanım Entegrasyonu', 'Veri Güvenliği'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'ABRH Kan Grubu Tespit Cihazı, dünya genelindeki sağlık alanında devrim niteliğinde bir yenilikle tanışmanızı sağlıyor. Yapay zeka destekli kan grubu tespit cihazımız, kan grubunu anlık olarak ve hızlı bir şekilde belirlemek için geliştirilmiş bu yenilikçi cihaz ile sağlık sektöründe devrim yaratıyoruz. Cihaz, kan damlatıldığında hızlı bir şekilde kan grubunu tespit ediyor ve sonucu anlık olarak kullanıcıya sunuyor. Bu sayede, acil durumlarda veya kan bağışı ihtiyacı olan kişilere hızlıca yardımcı olmak mümkün hale geliyor.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Gelenlikle parmağınızın uç kısmından veya kolunuzun damarlarından alınan küçük bir kan örneği ile hızlı sonuç alma ihtiyacı',
                'Acil durumlarda veya kan bağışı ihtiyacı olan kişilere saatlerce beklemeden hızlıca yardımcı olma gerekliliği',
                'Yapay zeka algoritmasının yüksek doğruluk oranı ile çalışması',
                'Kan numunesinin otomatik olarak işlenmesi ve analiz edilmesi',
                'Kullanıcı dostu bir arayüz ile web sitesinden sonuçların anında görüntülenmesi'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'Özel tasarlanmış uygulama ile kan numunesini özel cihaza yerleştirme ve otomatik işleme',
                'Güçlü yapay zeka algoritması ile kan örneğinin içeriğini inceleyerek hızlı analiz',
                'Doğruluk oranı yüksek algoritmalar ve yapay zeka teknolojisi kullanarak güvenilir sonuçlar',
                'Kullanıcı dostu web sitesi aracılığıyla cihazla bağlantı kurma ve sonuçları anında görüntüleme',
                'Veritabanına kaydedilen sonuçlar sayesinde gelecekteki ihtiyaçlar için hızlı erişim',
                'Tüm verilerin gizlilik politikalarımızla korunması ve veri güvenliği'
            ]
        },
        features: {
            title: 'Nasıl Çalışır ve Özellikler',
            items: [
                'Kan Numunenizi Hazırlayın: İlk adım, kan grubu tespiti için bir kan numunesi hazırlamaktır. Genellikle parmağınızın uç kısmından veya kolunuzun damarlarından alınan küçük bir kan örneği kullanılır',
                'Numuneyi Cihazınıza Yerleştirin: Özel tasarlanmış uygulamamızı açın ve kan numunesini özel cihazınıza yerleştirin. Bu cihaz, kan örneğinizi otomatik olarak işleyecektir',
                'Kan Numunenizi Analiz Edin: Güçlü bir yapay zeka algoritması devreye girer. Bu algoritma, kanın içerdiği özellikleri tanımlar ve hızlıca analiz eder',
                'Sonuçları Anında Web Sitesinden Görüntüleyin: Kan grubu tespiti sonuçları hemen web sitemizden erişilebilir durumda olacak. Bu sayede kan grubunuzu öğrenmek için saatlerce beklemek zorunda kalmazsınız',
                'Hızlı ve Kolay Kullanım: Uygulamamızın kullanımı oldukça basittir. Kan numunelerini hazırlayın, uygulamayı açın ve sonuçları anında alın',
                'Yüksek Doğruluk Oranı: Yapay zeka algoritmamız, yüksek doğruluk oranıyla sonuçları analiz eder ve kullanıcılara güvenilir bilgiler sunar',
                'Veri Güvenliği: Kullanıcılarımızın gizliliği bizim için öncelikldir. Tüm verileriniz gizlilik politikalarımızla korunur',
                'Sadece birkaç damla kan yeterli: Kısa bir süre sonra kan grubunuzu öğrenebileceksiniz',
                'Veritabanı kaydı: Gelecekteki ihtiyaçlarınız için hızlı erişim sağlayabileceksiniz'
            ]
        }
    }
];

